import React from 'react';

interface ITimer {
    isExpired: boolean;
    days: number
    minutes: number;
    seconds: number;
    hours: number;
}

const GeneralTimer = ({ isExpired, days, minutes, seconds, hours }: ITimer) => {
    return (
        <>
            {
                isExpired || (minutes === 0 && seconds === 0 && hours === 0) ?
                <></>
                :
                <>
                    {(days*24 + hours).toString().length === 1 ? "0" + (days*24 + hours).toString() : (days*24 + hours).toString()}
                    :{minutes.toString().length === 1 ? "0" + minutes.toString() : minutes.toString()}
                    :{seconds.toString().length === 1 ? "0" + seconds.toString() : seconds.toString()}
                </>
            }
        </>
    )
};

export default GeneralTimer;